<template>
    <pc-loader v-bind:loading="savingNote">
        <div class="mb-2">
            <pc-textarea
                id="NoteContentInput"
                ref="noteContentInput"
                v-model="noteContent"
                v-bind:label="noteContentInputLabel"
                v-bind:validator="noteContentValidator"
                v-bind:maxlength="maxNoteLength"
                v-on:validated="onNoteValidated" />
            <div class="mb-3 text-body-secondary fst-italic">
                {{ remainingChar }}
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-end">
            <pc-button
                id="BtnCancelNote"
                class="me-2"
                v-on:click="addNoteCancel">
                {{ cancelBtnLabel }}
            </pc-button>
            <pc-button
                id="BtnSaveNote"
                v-bind:disabled="!allowSave"
                primary
                v-on:click="addNoteSave">
                {{ saveBtnLabel }}
            </pc-button>
        </div>
    </pc-loader>
</template>
<script>
    import { NAMESPACE, KEYS } from "./i18n/addProjectNote.i18n";
    import { mapI18n } from "Util/i18n";
    import { getValidator, VALIDATOR_TYPES } from "Validation/validator";

    const MAX_NOTE_LENGTH = 2048;

    export default {
        props: {
            savingNote: { type: Boolean, required: false, default: false }
        },
        emits: ["add-note-cancel", "add-note-save"],
        data() {
            return {
                noteContent: null,
                noteContentValidator: getValidator(this.$app, [
                    {
                        type: VALIDATOR_TYPES.minLength,
                        minLength: 1,
                        overrideMsg: this.emptyContentValidationMessage
                    },
                    {
                        type: VALIDATOR_TYPES.maxLength,
                        maxLength: MAX_NOTE_LENGTH,
                        overrideMsg: this.oversizeContentValidationMessage
                    }
                ]),
                noteValidationResult: null,
                maxNoteLength: MAX_NOTE_LENGTH
            };
        },
        computed: {
            allowSave() {
                return (
                    !this.savingNote &&
                    this.noteContent &&
                    this.noteContent.trim() !== "" &&
                    (!this.noteValidationResult || !this.noteValidationResult.hasError)
                );
            },
            //Calculates number of characters available in the reply message
            noteRemainingChars() {
                if (!this.noteContent) {
                    return MAX_NOTE_LENGTH;
                }
                const remaining = MAX_NOTE_LENGTH - this.noteContent.length;
                return remaining > 0 ? remaining : 0;
            },
            ...mapI18n(
                {
                    ...KEYS,
                    remainingChar() {
                        return {
                            key: KEYS.remainingCharMsg,
                            values: { charactersRemaining: this.noteRemainingChars }
                        };
                    },
                    oversizeContentValidationMessage() {
                        return { key: KEYS.oversizeContentValidationMessage, values: { MAX_NOTE_LENGTH } };
                    }
                },
                NAMESPACE
            )
        },
        methods: {
            addNoteCancel() {
                this.$emit("add-note-cancel");
            },
            addNoteSave() {
                this.$emit("add-note-save", this.noteContent);
            },
            onNoteValidated(result) {
                this.noteValidationResult = result;
            },
            focusNoteContentInput() {
                this.$refs.noteContentInput.focusIn();
            }
        }
    };
</script>
